// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"b13877a2","541":"953ab56a","583":"db8eafec","623":"3d118532","672":"32ecfedd","846":"d4441dca","910":"ada5b8eb"}[chunkId] + ".chunk.js";
};